import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { UntypedFormControl } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { DateTime } from "luxon";
import { environment } from "../../../environments/environment";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { MatDialog } from "@angular/material/dialog";
import { BillImage } from "../../obj/BillImage";
import { Pair } from "../../obj/Pair";
import { SellerContract } from "../../entity/SellerContract";
import { KilowantContract } from "../../entity/KilowantContract";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { ContractStatus } from "../../obj/ContractStatus";
import { User } from "../../entity/User";
import { Account } from "../../entity/Account";
import { DatePipe, NgIf, CurrencyPipe } from "@angular/common";
import { HeaderComponent } from "../incs/header.component";


@Component({
    selector: "kilowant-seller-view-contract",
    templateUrl: "../../../html/seller/main-seller-view-contract.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, NgIf, CurrencyPipe, DatePipe]
})
export class SellerViewContractComponent extends AbstractSellerComponent {
    user: User = new User();
    contract: KilowantContract = null!;
    viewTerms: boolean = false;
    termFrom = new UntypedFormControl();
    termTo = new UntypedFormControl();
    isViewOnly: boolean = false;
    title: string = "";
    sellerTermsAndConditions: SellerContract[] = [];
    selectedSellerTermsAndConditions: SellerContract = null!;
    billImages: BillImage[];
    allowPendingCancel: boolean;
    showBuyerAddressLine2: boolean = false;
    showSellerAddressLine2: boolean = false;
    selectedBillImage: string = "";
    selectedBillAccountIndex: number = 1;
    accountNumberMask: string = "";
    accountNumbers: Pair[];
    accountNumber: string = "";

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        protected datepipe: DatePipe,
        dialog: MatDialog,
        private sanitizer: DomSanitizer
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
        this.route.params.forEach((params: Params) => {
            let id: string = params["id"];
            this.generalService.getContract(Number(id))
                .then(contract => {
                    this.contract = contract;
                    if ((this.contract.status == ContractStatus.PENDING) ||
                        (this.contract.status == ContractStatus.OPEN) ||
                        (this.contract.status == ContractStatus.CLOSED)
                    ) {
                        this.title = "View Price Plan";
                    } else {
                        this.goto('/seller/home/accepted-offers')
                    }
                    this.termFrom.setValue(DateTime.fromJSDate(this.contract.termFrom).toJSDate());
                    this.termTo.setValue(DateTime.fromJSDate(this.contract.termTo).toJSDate());
                    if (this.contract.detailsBuyerAddressLine2 != null && this.contract.detailsBuyerAddressLine2 != "") {
                        this.showBuyerAddressLine2 = true;
                    }
                    if (this.contract.detailsSellerAddressLine2 != null && this.contract.detailsSellerAddressLine2 != "") {
                        this.showSellerAddressLine2 = true;
                    }
                    var accountList = this.contract.detailsAccountNumbers.split(',');
                    this.accountNumbers = [];
                    for (var i = 0; i < accountList.length; i++) {
                        this.accountNumbers.push(new Pair(i, accountList[i]));
                    }
                    this.accountNumberMask = (this.contract.utility.accountTemplate == null) ? "" : this.contract.utility.accountTemplate;
                });
        });

        this.generalService.getSellerContracts()
            .then(cs => {
                if (cs != null) {
                    this.sellerTermsAndConditions = cs;
                }
            });
    }

    getAccountNumbers(accounts: Account[]): string {
        let outStr = "";
        for (let i = 0; i < accounts.length; i++) {
            outStr += accounts[i].accountNumber;
            if (i < accounts.length - 1) {
                outStr += ", ";
            }
        }
        if (outStr.length == 0) {
            return "-";
        }
        return outStr;
    }

    cancelledBy(contract: KilowantContract): string {
        let res = "";
        if (contract.cancelledDate != null) {
            res += "on " + this.datepipe.transform(contract.cancelledDate, "shortDate") + " @ " + this.datepipe.transform(contract.cancelledDate, "shortTime");
            if (contract.cancelledByBuyer) {
                res += " by " + this.user.firstName + " " + this.user.lastName;
            } else if (contract.cancelledSellerUser != null) {
                res += " by " + contract.cancelledSellerUser.firstName + " " + contract.cancelledSellerUser.lastName;
            }
        }
        return res;
    }

}
